/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 01.09.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import {VelocityTransitionGroup} from 'velocity-react';

import Translate from '../../Translate';

import {FetchAssetById} from '../../../actions/asset/action-asset';
import {ShareRequestInAir, ShareRequestDone} from '../../../actions/common/actions-common';

import _get from 'lodash/get';

class ShareRequestMessage extends Component {
  constructor(props) {
    super(props);

    this.animationEnterTop = {
      translateY: '0px',
      opacity: 1
    };

    this.animationLeaveTop = {
      translateY: '-100px',
      opacity: 0
    };

    this.animationEnterBottom = {
      translateY: '0px',
      opacity: 1
    };

    this.animationLeaveBottom = {
      translateY: '100px',
      opacity: 0
    };

    this.state = {
      assetPoster: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`,
      isShown: false
    };
  }

  componentWillMount() {
    this.props.FetchAssetById(_get(this.props, 'message.asset_id'));

  }

  componentDidMount() {

    this.setState({
      isShown: this.props.isShown
    });

    this._getMetadata();
  }

  componentWillReceiveProps(newProps) {

    this.setState({
      isShown: newProps.isShown
    });

    this._getMetadata(newProps);
  }

  _getMetadata(props = this.props) {

    if (props.asset.id) {

      lh.models.asset.methods.getPosterUrl(props.asset, {
        crop: {x: 408, y: 375},
        cache: false
      })
        .then((url) => {

          this.setState({
            assetPoster: url
          });
        }, ()=> {

          this.setState({
            assetPoster: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`
          });
        });
    }
  }

  _onYesClick() {

    this.setState({
      isShown: false
    });

    this.props.ShareRequestInAir(_get(this.props, 'message.asset_id'));

    this.props.onClose();
  }

  _onCrossClick() {

    this.setState({
      isShown: false
    });

    this.props.ShareRequestDone(_get(this.props, 'message.asset_id'));

    this.props.onClose();
  }

  render() {

    return (
      <div>
        {this.state.isShown && <a className="mw-close ico ico-close slider-resume" href="javascript:void(0)" onClick={this._onCrossClick.bind(this)}></a>}
        {this.state.isShown && <div>
          <div className="popup-block share">
            <VelocityTransitionGroup
              runOnMount={true}
              enter={{animation: this.animationEnterTop, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeaveTop, easing: 'ease-in-out', duration: 150}}>
              <div className="img-container">
                <img className="share-img" src={`/images/${Config.white_skin ? 'white' : 'black'}/screen.png`} />
                <img className="asset-img" src={this.state.assetPoster} />
              </div>
            </VelocityTransitionGroup>
            <VelocityTransitionGroup
              runOnMount={true}
              enter={{animation: this.animationEnterBottom, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeaveBottom, easing: 'ease-in-out', duration: 150}}>
              <div>
                <p>
                  <strong> <Translate content="messages.share_request.title" /> </strong>
                  <div className="pt">
                    <Translate content="messages.share_request.you_have_received" />&nbsp;<Translate content={`messages.share_request.${_get(this.props, 'message.asset_type')}`} />
                    <em style={{fontWeight: 'bold'}}> {_get(this.props, 'asset.title') || _get(this.props, 'message.title')} </em>
                    <Translate content="messages.share_request.sharing_notification" />
                  </div>
                </p>
              </div>
              <div className="mt+ message-actions">
                <Link to={'/asset/' + _get(this.props, 'message.asset_id')} className="btn-dark-popup yes" onClick={this._onYesClick.bind(this)}> <Translate content="yes" /> </Link>
                <a className="btn-dark-popup no" href="javascript:void(0)" onClick={this._onCrossClick.bind(this)}> <Translate content="no_thanks" /> </a>
              </div>
            </VelocityTransitionGroup>
          </div>
        </div>}
      </div>
    );
  }
}

ShareRequestMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    asset_type: PropTypes.string,
    asset_id: PropTypes.string.isRequired,
    position: PropTypes.number,
    title: PropTypes.string
  }),
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

const mapStateToProps = ({assets}, ownProps) => {
  let asset = _get(assets, _get(ownProps, 'message.asset_id'), {});

  return {
    asset: asset
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetById, ShareRequestInAir, ShareRequestDone}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareRequestMessage);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/ShareRequest/share-request-message.js